export const OWN_BRAND_NAME = 'AGM Vision'

function filled(value) {
  return value === null || value === undefined ? '' : String(value).trim()
}

export function schemaBrand(product) {
  return {
    '@type': 'Brand',
    name: filled(product?.brand?.name) || OWN_BRAND_NAME,
  }
}

export function isOwnBrandProduct(product) {
  const name = filled(product?.brand?.name)
  return !name || name.toLowerCase() === OWN_BRAND_NAME.toLowerCase()
}

export function schemaIdentifiers(product, variant) {
  const identifiers = {}
  const gtin = filled(variant?.gtin)
  if (gtin) identifiers.gtin = gtin
  const reference = filled(variant?.reference)
  if (reference && isOwnBrandProduct(product)) identifiers.mpn = reference
  return identifiers
}
